import {
    RecargosMora,
    ConfiguracionMora,
    InterestSettings,
    Houses,
    OrigenesCredito,
    ParametrosSistema
} from '../components/Configuraciones'

const routesConfiguraciones = [
    {
        path: '/configuraciones-casas',
        name: 'Casas',
        icon: 'nc-icon nc-bank',
        component: <Houses />,
        permissions: ['210_CASAS'],
        layout: '/app',
        visibility: true,
        subRoutes: []
    },
    {
        path: '/origenes-de-credito',
        name: 'Origenes de Credito',
        icon: 'nc-icon nc-bank',
        component: <OrigenesCredito />,
        permissions: ['252_ORIGENES_DE_CREDITO'],
        layout: '/app',
        visibility: true,
        subRoutes: []
    },
    {
        path: '/parametros-de-sistema',
        name: 'Parámetros de Sistema',
        icon: 'nc-icon nc-bank',
        component: <ParametrosSistema />,
        permissions: ['254_PARAMETROS'],
        layout: '/app',
        visibility: true,
        subRoutes: []
    },
    // {
    //     path: '/configuraciones-recargos-mora',
    //     name: 'Recargos Mora',
    //     icon: 'nc-icon nc-bank',
    //     component: <RecargosMora />,
    //     permissions: ['153_RECARGOS_DE_MORA'],
    //     layout: '/app',
    //     visibility: true,
    //     subRoutes: []
    // },
    // {
    //     path: '/configuraciones-interes-moras',
    //     name: 'Interés Moras',
    //     icon: 'nc-icon nc-bank',
    //     component: <ConfiguracionMora />,
    //     permissions: ['154_INERES_DE_MORA'],
    //     layout: '/app',
    //     visibility: true,
    //     subRoutes: []
    // },
    // {
    //     path: '/configuraciones-interes-creditos',
    //     name: 'Interés Creditos',
    //     icon: 'nc-icon nc-bank',
    //     component: <InterestSettings />,
    //     permissions: ['155_INTERES_DE_CRÉDITOS'],
    //     layout: '/app',
    //     visibility: true,
    //     subRoutes: []
    // },
]

export { routesConfiguraciones }
